"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("core.ui-module_site-components");
var _ApplicationContext = require("../../api/ApplicationContext");
var _OtpDeliveryMethodStepResponse = _interopRequireDefault(require("../../api/auth/OtpDeliveryMethodStepResponse"));
var _ReturnToLoginLink = _interopRequireDefault(require("./ReturnToLoginLink"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/* eslint-disable react/no-unused-state */

class OtpDeliveryMethodStep extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      deliveryMethod: '',
      deliveryMethods: [],
      // eslint-disable-next-line react/no-unused-state
      errorMessage: ''
    };
    this.returnToLogin = this.returnToLogin.bind(this);
  }
  componentDidMount() {
    const {
      stepResponse
    } = this.props;
    const deliveryMethods = stepResponse?.additionalData;
    if (deliveryMethods) {
      this.setState({
        deliveryMethods
      });
    }
  }
  validate(deliveryMethod) {
    const {
      deliveryMethods
    } = this.state;
    let isValid = false;
    deliveryMethods.forEach(dm => {
      if (dm.uid === deliveryMethod) {
        isValid = true;
      }
    });
    return isValid;
  }
  submit(e) {
    const {
      listener
    } = this.props;
    const {
      deliveryMethod
    } = this.state;
    e.preventDefault();
    this.setState({
      errorMessage: '',
      isLoading: true
    });
    const step = new _OtpDeliveryMethodStepResponse.default();
    step.uuid = deliveryMethod;
    listener(this, step);
  }
  change(value) {
    this.setState({
      deliveryMethod: value
    });
  }
  returnToLogin(e) {
    const {
      listener,
      history
    } = this.props;
    e.preventDefault();
    this.setState({
      errorMessage: '',
      isLoading: true
    });
    listener('InitializeAuthentication', null);
    history.push(_ApplicationContext.ApplicationContext.getLoginPath());
  }
  render() {
    const {
      rawErrorMessage,
      isLoading,
      deliveryMethods,
      deliveryMethod
    } = this.state;
    const disabled = !this.validate(deliveryMethod) && !rawErrorMessage;
    const options = deliveryMethods.map(dm => ({
      id: `delivery_method_${dm.uid}`,
      label: dm.maskedDestination,
      name: 'deliveryMethod',
      value: dm.uid
    }));
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: `lds-spinner-overlay ${isLoading && 'is-active'}`
    }, isLoading && /*#__PURE__*/_react.default.createElement(_core.Spinner, null)), /*#__PURE__*/_react.default.createElement("form", {
      id: "otpForm"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "login-box content"
    }, /*#__PURE__*/_react.default.createElement(_core.Block, null, /*#__PURE__*/_react.default.createElement(_core.Title, {
      renderAs: "p"
    }, "Verify Your Identity"), /*#__PURE__*/_react.default.createElement(_core.SubTitle, {
      renderAs: "p",
      textAlign: "left"
    }, "Choose an email or text-enabled phone number to receive a security code."), /*#__PURE__*/_react.default.createElement(_core.RadioButtonGroup, {
      name: "deliveryMethod",
      textAlign: "left",
      options: options,
      required: true,
      error: rawErrorMessage,
      onChange: option => this.change(option.value),
      onBlur: option => this.change(option.value)
    }), /*#__PURE__*/_react.default.createElement(_core.Content, {
      size: "small",
      pl: 0
    }, "By selecting a number that is text-enabled, you agree the text notification is subject to the\xA0", /*#__PURE__*/_react.default.createElement("span", {
      className: "is-underlined is-clickable"
    }, "MissionSquare Retirement Text Access Terms and Conditions"), ".")), /*#__PURE__*/_react.default.createElement(_core.Buttons, {
      className: "field-submit-button"
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      handleClick: e => this.submit(e),
      disabled: disabled
    }, "Send Security Code")), /*#__PURE__*/_react.default.createElement(_ReturnToLoginLink.default, {
      returnToLogin: this.returnToLogin
    }))));
  }
}
OtpDeliveryMethodStep.propTypes = {
  listener: _propTypes.default.func.isRequired,
  stepResponse: _propTypes.default.shape({
    additionalData: _propTypes.default.shape({
      message: _propTypes.default.string
    })
  }),
  history: _propTypes.default.shape({
    push: _propTypes.default.func.isRequired
  })
};
var _default = exports.default = (0, _reactRouterDom.withRouter)(OtpDeliveryMethodStep);
//# sourceMappingURL=OtpDeliveryMethodStep.js.map